export default "__VITE_ASSET__CSnnoGO$__"